import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import RoutePath from 'App/RoutePath';
import { LoggedOutScreenWrapper } from '../../LoggedOutScreenWrapper';
import { Container, Title, Description, Button } from './styles';

export const InviteesLimitReached = () => {
  const history = useHistory();
  const { t: translate } = useTranslation('logged_out');

  return (
    <LoggedOutScreenWrapper>
      <Container data-testid="error-screen">
        <Title>
          {translate('sign_up.invalid_token.invitees_limit_reached.title')}
        </Title>
        <Description>
          {translate(
            'sign_up.invalid_token.invitees_limit_reached.description',
          )}
        </Description>
        <Button
          variant="primary"
          type="submit"
          ariaLabel={translate(
            'sign_up.invalid_token.invitees_limit_reached.button_a11y_text',
          )}
          onClick={() => history.push(RoutePath.Home)}
          label={translate(
            'sign_up.invalid_token.invitees_limit_reached.button',
          )}
        />
      </Container>
    </LoggedOutScreenWrapper>
  );
};
